import React, { useState } from 'react';
import { Range, getTrackBackground } from 'react-range';


const CategoriesFilterPrice = ({ heading, text, button, priceFilterStart, filter, priceFilter, setPriceFilter, currency }) => {
  const [values, setValues] = useState([0, 1]);
  return (
    <div className="categoriesFilterPrice">
      <h3 className="heading--small">{heading}</h3>
      <div className="categoriesFilterPrice__wrapper">
        <Range
          values={priceFilter}
          step={1}
          min={priceFilterStart[0]}
          max={priceFilterStart[1]}
          // rtl={rtl}
          onChange={(values) => {
            setValues(values)
            setPriceFilter(values);
            filter(values)
          }}
          renderTrack={({ props, children }) => (
            <div
              onMouseDown={props.onMouseDown}
              onTouchStart={props.onTouchStart}
              style={{
                ...props.style,
                height: '25px',
                display: 'flex',
                width: '100%',
                paddingLeft: '8px',
                paddingRight: '8px',
              }}
            >
              <div
                ref={props.ref}
                style={{
                  height: '5px',
                  width: '100%',
                  borderRadius: '4px',
                  background: getTrackBackground({
                    values: priceFilter,
                    colors: ['#ccc', '#628942', '#ccc'],
                    min: priceFilterStart[0],
                    max: priceFilterStart[1],
                    rtl: false
                  }),
                  alignSelf: 'center'
                }}
              >
                {children}
              </div>
            </div>
          )}
          renderThumb={({ props }) => (
            <div
              {...props}
              style={{
                ...props.style,
                height: '15px',
                width: '15px',
                borderRadius: '50%',
                backgroundColor: '#628942',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                // boxShadow: '0px 2px 6px #AAA'
              }}
            >
            </div>
          )}
        />
        <div className="categoriesFilterPrice__info">
          <output id="output">
            {text} {priceFilter[0].toFixed(0)}{currency} - {priceFilter[1].toFixed(0)}{currency}
          </output>
          <div className="categoriesFilterPrice__button">
            <button className="btn btn--secondary" onClick={(e => { filter('price', priceFilter) })}>{button}</button>
          </div>
        </div>
      </div>
    </div>
  )

}
export default CategoriesFilterPrice
